const text = (value) => (value === null || value === undefined ? '' : String(value).trim());

const BRAND_ALIASES = {
  CHEVROLET: 'C',
  CHEVY: 'C',
  C: 'C',
  BUICK: 'B',
  B: 'B',
  GMC: 'G',
  G: 'G',
  CADILLAC: 'CAD',
  CAD: 'CAD',
  K: 'CAD',
};

const FULL_NAME_BRANDS = [
  ['CHEVROLET', 'C'],
  ['CADILLAC', 'CAD'],
  ['BUICK', 'B'],
  ['GMC', 'G'],
];

const parseCompactFullNameBrandTokens = (word) => {
  const tokens = [];
  let index = 0;
  while (index < word.length) {
    const match = FULL_NAME_BRANDS.find(([name]) => word.startsWith(name, index));
    if (!match) return [];
    tokens.push(match[1]);
    index += match[0].length;
  }
  return tokens;
};

const parseBrandTokens = (value) => {
  const raw = text(value);
  if (!raw) return [];
  const upper = raw.toUpperCase();
  const words = upper.match(/[A-Z]+/g) || [];
  const direct = words.flatMap((word) => {
    if (BRAND_ALIASES[word]) return [BRAND_ALIASES[word]];
    const compactFullNames = parseCompactFullNameBrandTokens(word);
    if (compactFullNames.length) return compactFullNames;
    const compact = [];
    let index = 0;
    while (index < word.length) {
      if (word.startsWith('CAD', index)) {
        compact.push('CAD');
        index += 3;
        continue;
      }
      const char = word[index];
      if (char === 'C' || char === 'B' || char === 'G' || char === 'K') {
        compact.push(char === 'K' ? 'CAD' : char);
        index += 1;
        continue;
      }
      return [];
    }
    return compact;
  });
  return direct.filter(Boolean);
};

export const normalizeBillingBrandCode = (value) => {
  const tokens = [...new Set(parseBrandTokens(value))];
  if (!tokens.length) return text(value);
  const hasC = tokens.includes('C');
  const hasB = tokens.includes('B');
  const hasG = tokens.includes('G');
  const hasCad = tokens.includes('CAD');
  return [
    hasC ? 'C' : '',
    hasB && hasG ? 'BG' : hasB ? 'B' : hasG ? 'G' : '',
    hasCad ? 'CAD' : '',
  ].join('');
};

export const billingBrandLabel = (rowOrValue = {}) => {
  if (typeof rowOrValue !== 'object' || rowOrValue === null) return normalizeBillingBrandCode(rowOrValue);
  return normalizeBillingBrandCode(
    rowOrValue.brand
      || rowOrValue.productBrand
      || rowOrValue.product_brand
      || rowOrValue.brandCode
      || rowOrValue.cpqOnlyEvidenceSummary?.brand,
  );
};
